import { createSvgComponent } from "../../icon/createSvgComponent";
import EditImage from "@core/__generated__/icon/figma/edit-image.svg";
export default createSvgComponent(EditImage);